@if (showPersonendaten()) {
  <ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
} @else {
  <div>
    <span style="font-style: italic">{{ "stammperson-auskunftsperre" | translate }}</span>
  </div>
}

<ng-template #typ00>
  <ng-template [ngTemplateOutlet]="typ01"></ng-template>
  @if (item.ledigname) {
    <span> ({{ item.ledigname }})</span>
  }
  @if (item.geburtsdatum) {
    <span>, {{ item.geburtsdatum | dayMonthYearDate }}</span>
  }
  @if (item.ahvNummer?.ahv13?.ahvnummer13) {
    <span>, {{ item.ahvNummer.ahv13.ahvnummer13 | formatAhv }}</span>
  }
  @if (item.sitz) {
    <span>, {{ item.sitz }}</span>
  }
  @if (item.uid) {
    <span> ({{ "UID" | translate }}: {{ item.uid | formatUid }})</span>
  }
</ng-template>

<ng-template #typ01>
  <ng-template [ngTemplateOutlet]="auskunftsperre"></ng-template>
  {{ item.name }}
  @if (item.vorname) {
    <span> {{ item.vorname }}</span>
  }
</ng-template>

<ng-template #typ02>
  <ng-template [ngTemplateOutlet]="typ01"></ng-template>
  @if (item.sitz) {
    <span>, {{ item.sitz }}</span>
  }
</ng-template>

<ng-template #auskunftsperre>
  @if (hasAuskunftsperre && hasPermissionAuskunft) {
    <div class="float-start me-2">
      <span
        [ngbTooltip]="'stammperson-auskunftsperre-mitBerechtigung' | translate"
        [placement]="'bottom'"
        class="ms-1 fas fa-exclamation-triangle text-warning"></span>
    </div>
  }
</ng-template>
